import {isEmptyOrNull} from "../common/NamaCommon";
import * as CommonConstants from "../constants/CommonConstants";

export function toCSVLineWithSep(separator, objects) {
    if (!objects)
        return "";
    let line = "";
    for (let i = 0; i < objects.length; i++) {
        line += objects[i] === null ? "" : objects[i];
        if (i < objects.length - 1) {
            line += separator;
        }
    }
    return line;
}

export function getAllInnerStrings(source, operBraket, closedBracket) {
    let innerStrings = [];
    let current;
    while ((current = getInnerString(source, operBraket, closedBracket))) {
        innerStrings.push(current);
        source = source.replace(operBraket + current + closedBracket, "&_$rp(^_^)cd$_&");
    }
    return innerStrings;
}

export function getInnerStr( source,  openBraket,  closedBracket)
{
    return getInnerString(source, openBraket, closedBracket, "####null#####");
}

function getInnerString( source, operBracket, closedBracket, innerValue)
{
    if (!source)
        return null;
    let startIndex = source.indexOf(operBracket);
    if (startIndex < 0)
        return null;
    let inners = 0;
    let endIndex = -1;
    for (let i = startIndex + operBracket.length; i < source.length; i++)
    {
        if (source.substring(i,source.length).startsWith(innerValue))
        {
            inners++;
        }
        else if (source.substring(i,source.length).startsWith(closedBracket))
        {
            if (inners == 0)
            {
                endIndex = i;
                break;
            }
            else
            {
                inners--;
            }
        }
    }

    return source.substring(startIndex + operBracket.length, endIndex);
}

export function substringBeforeLast(str, separator) {
    if (!str || !separator)
        return str;
    if (separator.length == 0)
        return "";
    let pos = str.lastIndexOf(separator);
    if (pos === -1)
        return str;
    return str.substring(0, pos);
}

export function normalizeArabic(arabic) {
    return replaceChars(arabic, CommonConstants.ARABIC_REPLACE___, CommonConstants.ARABIC_REPLACE_BY);
}

export function arabicToEnglish(str) {
    return replaceChars(str, CommonConstants.ARABIC_KEYBOARD_, CommonConstants.ENGLISH_KEYBOARD);
}

export function englishToArabic(str) {
    return replaceChars(str, CommonConstants.ENGLISH_KEYBOARD, CommonConstants.ARABIC_KEYBOARD_);
}

export function replaceChars(str, replace, replaceBy) {
    if (isEmptyOrNull(str))
        return str;
    for (let i = 0; i < replace.length; i++)
        str = str.replaceAll(replace[i], replaceBy[i]);
    return str;
}